import React from 'react';
// import '../assets/css/Sketches.css'; 
import SketchItem from './pages/SketchItem';

const SketchGrid = (props) => {
    const sketches = props.sketches.map((sketch) => {
        return (
            <SketchItem
                className="Sketch-Item"
                key={sketch.id}
                sketch={sketch}
            />
        );
    });

    return (
        <div className="Sketch-Grid">
            { sketches}
        </div>
    );
}

export default SketchGrid;
